<style>
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Perfil
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Notificação</h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-12">
          <div class="card mb-4">
         
            <div class="card-body px-0 pt-0 pb-2">
              <div class="modal-body">
              <div class="col-md-12">
                <div class="form-group">
                  
                  <h3>
                    {{ notificacao.titulo }}
                  </h3>
                  
                  <hr>
                  <label for="example-text-input" class="form-control-label"
                    >Conteúdo</label
                  >

                  <h4>
                    {{ notificacao.conteudo }}
                  </h4>

                  <hr>
                  <label for="example-text-input" class="form-control-label"
                    >Enviado dia:</label
                  >
                  <p>{{ formatarData(notificacao.created_at) }}</p>
                </div>
                
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Enviado para:</label
                  >

                  <h5>
                    <div>
                     
                      <div>
                        <li v-for="item in dados" :key="item.id" style="list-style: none;">
                          
                          <span class="badge badge-sm bg-gradient-success">
                            {{ item.user }}
                          </span>
                          - 
                          <span class="badge badge-sm bg-gradient-success">
                            {{ item.prefeitura }}
                          </span>
                           - 
                           
                           <span class="badge badge-sm " :class="
                            item.status == 'lido'
                              ? 'bg-gradient-success'
                              : item.status == 'nao_lido'
                              ? 'bg-gradient-danger'
                              : 'bg-gradient-warning'
                          ">
                            {{ item.status == 'lido'
                              ? 'Lido'
                              : item.status == 'nao_lido'
                              ? 'Não lido'
                              : 'Não visualizado' }}
                          </span>
                        </li>
                      </div>
                    </div>
                  </h5>
                </div>
               
              </div>
            </div>
            </div>
  
          </div>
        </div>
      </div>

     
     
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Components/Pagination";
import moment from "moment";
import axios from "axios";

export default {
  props: ["user", "notificacao", "dados"],
  components: {
    AdminLayout,
    Pagination,
    moment,
  },

  data() {
    return {
      prefeitura: [], 


    };
  },

  computed: {
    
  },

  watch: {
    
  },

  methods: {
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
    
  },

  async mounted() {
  },
};
</script>

